// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MailFilledSvg from "@fishx/icons-svg/es/asn/MailFilled";
import FishxIcon from '../components/FishxIcon';

var MailFilled = function MailFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MailFilledSvg
  }));
};

MailFilled.displayName = 'MailFilled';
export default React.forwardRef(MailFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MailFilled.js
// module id = 3086
// module chunks = 0